import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

const useZohoUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 100,
    totalCount: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
  });

  // Get authentication token
  const getHeaders = () => {
    const storedUser = localStorage.getItem('user');
    const token = storedUser ? JSON.parse(storedUser).token : null;
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
  };

  // Fetch Zoho users
  const fetchUsers = useCallback(async (page = 1, limit = 10, status = null) => {
    setLoading(true);
    setError(null);
    try {
      let url = `${base_url}api/zoho-users?page=${page}&limit=${limit}`;
      if (status) {
        url += `&status=${status}`;
      }

      const { data } = await axios.get(url, getHeaders());
      
      setUsers(data?.users || []);
      setPagination(data?.pagination || {
        page: 1,
        limit: 10,
        totalCount: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPrevPage: false,
      });
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to fetch Zoho users');
      setUsers([]);
      setPagination({
        page: 1,
        limit: 10,
        totalCount: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPrevPage: false,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    users,
    loading,
    error,
    pagination,
    fetchUsers,
  };
};

export default useZohoUsers;
